import React from 'react'
import { FilterSection , VideoSection } from "../../component/index"
function VideoListingPage() {
    return (
        <div>
            <FilterSection />
            <VideoSection />
        </div>
    )
}
export default VideoListingPage;